// extracted by mini-css-extract-plugin
export default {"title":"CustomerReferenceGuideManagementPage_title__CETA8","referenceGuides":"CustomerReferenceGuideManagementPage_referenceGuides__kPKph"};